import { RootState } from '../../redux/store';
import { CopyMenuState } from './CopyMenuState';

export const selectCopyMenuState = (state: RootState): CopyMenuState => state.menuBuilder.copyMenu;
